/* eslint-disable class-methods-use-this */
import type { Nullable } from '../../../types';
import { User } from '../../../entities';
import { UserStorage } from '../userStorage';
import LocalStorageActions, {
  LocalStorageKeys,
} from '../../localStorageActions';

export default class UserStorageImpl implements UserStorage {
  getUserData(): Nullable<string> {
    return LocalStorageActions.getItem(LocalStorageKeys.user);
  }

  saveUserData(user: User): void {
    LocalStorageActions.setItem(LocalStorageKeys.user, user.id);
  }

  deleteUserData(): void {
    LocalStorageActions.deleteItem(LocalStorageKeys.user);
  }
}
